import { signal } from '@preact/signals-core';

// State signals
export const isLoading = signal(false);
export const authError = signal<string | null>(null);
export const isAuthenticated = signal(false);
